<template>
	<div id="panel_article_useful" class="panel useful theme-light my-0">
		<div class="container">
			<div class="panel_header">
				<div class="row align-items-end">
					<div class="col-12 col-lg-12">
						<h2>Читайте также</h2>
					</div>
				</div>
				<!--<nuxt-link class="panel_control" to="#"></nuxt-link>-->
			</div>
			<div class="row">
				<div
					v-for="(item, index) in filterArticles.slice(0, 3)"
					class="col-12 col-md-6 col-lg-4 mb-4"
					:class="{'d-none d-md-block d-lg-none' : index === 9}"
				>
					<div :class="'useful-item ' + contentIconMap[item.content_type]">
						<div>
							<div class="useful-item_top">
								<div class="tag_string">
									<span
										v-for="author in item.authors"
										v-if="item.authors !==null"
									>
										{{ author.title }}
									</span>
								</div>
								<div class="date">
									{{ item.date | moment("DD MMMM YYYY") }}
								</div>
							</div>
							<nuxt-link
								:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
								class="title"
							>
								{{ item.title }}
							</nuxt-link>
						</div>
						<div v-if="item.content_type === 1" class="useful-item_bottom">
							<nuxt-link
								:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
								target="_blank"
								class="more_link"
							>
								{{ $t('watch') }}
							</nuxt-link>
						</div>
						<div v-else-if="item.content_type === 2" class="useful-item_bottom">
							<nuxt-link
								:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
								target="_blank"
								class="more_link"
							>
								{{ $t('listen') }}
							</nuxt-link>
						</div>
						<div v-else-if="item.content_type === 0" class="useful-item_bottom">
							<nuxt-link
								:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
								target="_blank"
								class="more_link"
							>
								{{ $t('read') }}
							</nuxt-link>
						</div>
						<div v-else class="useful-item_bottom">
							<nuxt-link
								:to="$url.media(item.slug, item.taxonomy_type_slug, {}, item.lang)"
								target="_blank"
								class="more_link"
							>
								{{ $t('more') }}
							</nuxt-link>
						</div>
					</div>
				</div>
				<!-- Четвертый элемент d-lg-none -->
			</div>
			<div class="panel_footer">
				<div class="row">
					<div class="col-12 col-md-4 col-lg-3">
						<a href="/navigator/content/" class="btn btn-primary">{{ $t('moreNews') }}</a>
					</div>
					<div class="col-12 col-md-8 col-lg-6 offset-lg-4" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {
	Swiper,
	SwiperSlide,
	directive,
} from 'vue-awesome-swiper';
import '@/utils/moment';

export default {
	name: 'IssueUsefulContentPanel',
	components: {
		Swiper,
		SwiperSlide,
	},
	directives: {
		swiper: directive,
	},
	props: [
		'content',
		'block_title',
		'listData',
		'category',
		'taxonomy_type',
	],
	data() {
		return {
			options: {
				slidesPerView: 'auto',
				spaceBetween: 30,
				// freeMode: true,
				loop: false,
			},
			usefulContentData: [],
			contentTypeMap: {
				0: 'Статья',
				1: 'Видео',
				2: 'Подкаст',
			},
			contentIconMap: {
				0: 'text',
				1: 'video',
				2: 'audio',
			},
		};
	},
	computed: {
		filterArticles() {
			if (!this.usefulContentData.data) {
				return this.usefulContentData;
			}
			return [...this.usefulContentData.data].sort(() => .5 - Math.random()).slice(0, 4);
		},
	},
	mounted() {
		this.$axios
			.get(`${process.env.baseURL}/api/content/list?sort_by=date&order_by=desc`)
			.then((response) => (this.usefulContentData = response.data));
	},
};
</script>

<style lang="scss" scoped>
	@import '~/assets/styles/components/blocks/issue-useful-content-panel';

	.panel {
		margin: 5rem 0 0 0;
	}
	.panel_footer {
		border-top: 0;
		padding: 0;
	}
</style>
